module.exports = __webpack_public_path__ + "media/images/emblems/Blason_Valbroye-9e0a474ba7a9c5b69480e2025f5ab1f4.png";